import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_left_white",
  "use": "icon-icon_arrow_left_white-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-icon_arrow_left_white\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"m8.836 10.967 6.903 7.037H13.01L6 10.967l7.01-6.96h2.729z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol